import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Sair", -1)

import {
  LogOut,
} from 'lucide-vue-next';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import Avatar from '@/components/ui/avatar/Avatar.vue';
import AvatarFallback from '@/components/ui/avatar/AvatarFallback.vue';
import AvatarImage from '@/components/ui/avatar/AvatarImage.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderAvatarMenu',
  emits: ['LOGOUT'],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DropdownMenu), null, {
    default: _withCtx(() => [
      _createVNode(_unref(DropdownMenuTrigger), { "as-child": "" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Button), {
            variant: "ghost",
            size: "circle-icon"
          }, {
            default: _withCtx(() => [
              _createVNode(Avatar, null, {
                default: _withCtx(() => [
                  _createVNode(AvatarImage, {
                    src: "/img/bg_login_reduce.jpg",
                    alt: "@radix-vue"
                  }),
                  _createVNode(AvatarFallback, null, {
                    default: _withCtx(() => [
                      _createTextVNode("CN")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(DropdownMenuContent), { class: "w-56" }, {
        default: _withCtx(() => [
          _createVNode(_unref(DropdownMenuItem), {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('LOGOUT')))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(LogOut), { class: "mr-2 h-4 w-4" }),
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})